<template>
    <div class="trash-can">
      <h3>Trash Can</h3>
      <ul>
        <li v-for="order in orders" :key="order.partNumber">
          {{ order.partNumber }} - {{ order.quantity }}
          <button @click="$emit('restore-order', order.partNumber)">Restore</button>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      orders: Array
    }
  };
  </script>
  
  <style scoped>
  .trash-can {
    border: 1px solid #ccc;
    padding: 10px;
    margin-top: 20px;
  }
  </style>
  